import { render } from "./Privacy.vue?vue&type=template&id=b142e500&scoped=true&ts=true"
import script from "./Privacy.vue?vue&type=script&lang=ts"
export * from "./Privacy.vue?vue&type=script&lang=ts"

import "./Privacy.vue?vue&type=style&index=0&id=b142e500&lang=scss&scoped=true"

import exportComponent from "/home/kenddriz/Public/locaa/front/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b142e500"]])

export default __exports__